import Col from "@visa/vds/col";
import Row from "@visa/vds/row";
import MCSReadonlyField from "../../../components/MCSReadonlyField";
import React from "react";
import FormControl from "@visa/vds/form-control";

const VmidRecordStaticInfo = (props) => {
  return (
    <>
      <Row>
        <FormControl position="left" space="seventy">
          <MCSReadonlyField
            label="VMID"
            text={props.vmidRecord && props.vmidRecord.vmid}
          />
        </FormControl>
      </Row>
      <Row>
        <FormControl position="left" space="seventy">
          <MCSReadonlyField
            label="VMID Merchant Name"
            text={props.vmidRecord && props.vmidRecord.vmidMerchantName}
          />
        </FormControl>
      </Row>
      <Row>
        <FormControl position="left" space="seventy">
          <MCSReadonlyField
            label="3DS DAF Global Participation (Parameter A)"
            text={props.vmidRecord && props.vmidRecord.parameterAName}
          />
        </FormControl>
      </Row>
      <Row>
        <FormControl position="left" space="seventy">
          <MCSReadonlyField
            label="3DS DAF EU Participation (Parameter B)"
            text={props.vmidRecord && props.vmidRecord.parameterBName}
          />
        </FormControl>
      </Row>
    </>
  );
};

export default VmidRecordStaticInfo;
